import classNames from 'classnames'

import { ModalButton } from '@apps-common/components/modals'
import { InfoModal } from '@apps-common/components/modals/info-modal/InfoModal'
import { commonIcons } from '@apps-common/config/icons'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'

interface IProps {
  subtitle: string
  title: string
  body: any
  className?: string
  iconClasses?: string
}

export const InfoModalButton: React.FC<IProps> = ({ subtitle, title, body, className, iconClasses }) => (
  <ModalButton
    classes={classNames('action-info', className)}
    component={InfoModal}
    componentProps={{
      subtitle,
      title,
      body
    }}
    enterAnimation={modalSlideUpEnterAnimation}
    leaveAnimation={modalSlideUpLeaveAnimation}
  >
    <commonIcons.info className={classNames(iconClasses || 'z-[20] text-[22px] opacity-70')} />
  </ModalButton>
)
